module.exports = __webpack_public_path__ + "img/Fernsprech_Bau_und_Betriebstrupp.cfb9ac1e.svg";